import { InjectionToken } from '@angular/core';
import { GrowthBook } from '@growthbook/growthbook';
import { BehaviorSubject } from 'rxjs';
export const GROWTHBOOK = new InjectionToken<GrowthBook>('GrowthBook');

export const gb = (
  expertimentViewed: BehaviorSubject<{
    name: string;
    featureId: string;
    resultValue: string;
  }>
) => {
  return new GrowthBook({
    enableDevMode: false,
    // Only required for A/B testing. Called every time a user is put into an experiment
    trackingCallback: (experiment, result) => {
      expertimentViewed.next({
        name: experiment.name,
        featureId: result.featureId,
        resultValue: result.value,
      });
    },
  });
};
